import { IGlobalState } from '../states/GlobalState';
import { clearIdentityFromStorage } from '../types/auth';
import { GetConfiguration } from '../utils/config';
import { User } from 'oidc-client';

export function getHeaders(global: IGlobalState): Headers {

    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('IP', global.ip);
    
    global.auth.user && headers.append("Authorization", `Bearer ${global.auth.user.access_token}`);
    return headers;
}


export function handleErrors(response: any, global: IGlobalState) {
    if (!response.ok) {
        if (response.status === 401) //unauthorzied
        {
            global.auth.userManager.signoutRedirect();
        }
        else {
            console.log('handleErrors', response)
            throw Error(response.statusText);
        }
    }
    return response;
}


export const loggaAccesso = (prov: string, username: string, tipo: number, global: IGlobalState) => {
    //let fake_prov = (prov === undefined || prov === null) ? "44" : prov;
    console.log('Sono in log accesso');
    const url = `${GetConfiguration().api_url}/consultools/loguser/${username}/${tipo}`
    console.log('loguser', url)
    return window.fetch(url, {
        method: 'GET',
        headers: getHeaders(global)
    })
        .then(res => handleErrors(res, global))
        .then(res => res.json())
        .then(json => {
            const rv = (json as boolean);
            return rv;
        })
        .catch(error => {
            console.log('loguser error:', error); 
            throw new Error(error)
        })
        .finally(() =>{
            clearIdentityFromStorage();
        });
}
